import {
    container,
    defaultFont,
    minHeight,
    appbarHeight,
    drawerWidth
} from "./../psacount";

const topbarStype = {
    Buttons: {
        ...defaultFont,
        color: "#000000"
    },
    Divs: {
        ...defaultFont,
        color: "#000000"
    },
    txt: {
        ...defaultFont,
        color: "#000000"

    },
    Typographytop: {
        display: "block !important",
        overflow: "visible !important"
    },
    MenuItemtop: {
        ...defaultFont,
        color: "#000000"
    }
}

export default topbarStype;